import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { iconFor } from '../navigation/icons';

/** A card on Home or in the Settings hub, from an entry in navigation/modules.js. */
const ModuleCard = ({ module, color }) => {
    return (
        <Link to={module.path} data-testid={`card-${module.key}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="card module-card" style={{ borderTop: `4px solid ${color}` }}>
                <div style={{ background: `${color}20`, width: 'fit-content', padding: '0.75rem', borderRadius: '0.85rem', marginBottom: '1rem', color }}>
                    {React.createElement(iconFor(module.icon), { size: 26 })}
                </div>
                <h3 style={{ fontSize: '1.25rem', margin: '0 0 0.5rem' }}>{module.title}</h3>
                <p style={{ color: 'var(--text-muted)', margin: '0 0 1rem', flex: 1 }}>{module.description}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color, fontWeight: 600 }}>
                    Open <ArrowRight size={16} />
                </div>
            </div>
        </Link>
    );
};

export default ModuleCard;
